import React, { Fragment } from "react";
import { Urls } from "../../../constants/UrlConstants";
import layoutStyle from "../../../assets/css/modules/shared/layout.css";

const title = "Your account has moved to AXA Health";

export const MovedToAxaHealth = {
  browserTitle: "Migrated account",
  pageTitle: title,
  heading: title,
  description: (
    <Fragment>
      <p>
        We’ve brought all of our brands together under one name to make it
        simpler for all of our members.
      </p>
      <p>
        Please go to your new AXA Health{" "}
        <a
          className={`hol-link ${layoutStyle.anchorDecorationUnderline}`}
          href={Urls.MOL.Prod}
          rel="noopener noreferrer"
          target="_blank"
        >
          member site
        </a>{" "}
        to access your plan information, including any existing claims details.
        You’ll be asked to register with your email address and membership
        number, so that we can check your information and ensure all your data
        is kept safe.
      </p>
      <p>
        This now replaces the Health-on-Line portal, so we recommend saving it
        to your favourites for easy access.
      </p>
    </Fragment>
  ),
  AddANewPlanLinkText: "Link another policy"
};
